import React from "react";

function ShippingPage() {
  return (
    <section className="jh-container jh-section">
      <h1 className="jh-title">Shipping</h1>
      <p className="jh-sub">
        Every Ridley Jewelry piece is made to order. Please allow 2–3 weeks for
        production before your order ships.
      </p>

      <div style={{ maxWidth: 760, margin: "0 auto" }}>
        <h2 className="jh-title" style={{ fontSize: 22, marginTop: 24 }}>
          Shipping options
        </h2>
        <p className="jh-sub" style={{ marginTop: 8 }}>
          You can select your shipping method at checkout.
        </p>

        <div style={{ marginTop: 12 }}>
          <div style={{ fontWeight: 700 }}>Standard Shipping</div>
          <div className="jh-note" style={{ marginTop: 6 }}>
            Ships after production. Delivery time depends on carrier routing.
          </div>
        </div>

        <div style={{ marginTop: 12 }}>
          <div style={{ fontWeight: 700 }}>Insured Shipping</div>
          <div className="jh-note" style={{ marginTop: 6 }}>
            Recommended for higher-value orders.
          </div>
        </div>

        <h2 className="jh-title" style={{ fontSize: 22, marginTop: 24 }}>
          Order updates
        </h2>
        <p className="jh-sub" style={{ marginTop: 8 }}>
          You’ll receive an email confirmation after checkout, and a shipping
          update once your order has been fulfilled.
        </p>

        <h2 className="jh-title" style={{ fontSize: 22, marginTop: 24 }}>
          Questions
        </h2>
        <p className="jh-sub" style={{ marginTop: 8 }}>
          Email support@ridleyjewelry.com and we’ll help right away.
        </p>
      </div>
    </section>
  );
}

export default ShippingPage;
